var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0173 7.67028C17.6903 7.67728 18.6253 7.68028 19.4193 7.67728C19.8253 7.67628 20.0323 7.18528 19.7503 6.89028C19.2413 6.35628 18.5323 5.61028 17.8193 4.86228C17.1043 4.11128 16.3863 3.35628 15.8633 2.80828C15.5753 2.50428 15.0703 2.71328 15.0703 3.13328V5.70328C15.0703 6.78228 15.9493 7.67028 17.0173 7.67028Z",
    fill: "#BCBCBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8579 13.811H8.12994C7.71594 13.811 7.37994 13.475 7.37994 13.061C7.37994 12.647 7.71594 12.311 8.12994 12.311H14.8579C15.2719 12.311 15.6079 12.647 15.6079 13.061C15.6079 13.475 15.2719 13.811 14.8579 13.811ZM12.5889 17.232H8.12994C7.71594 17.232 7.37994 16.896 7.37994 16.482C7.37994 16.068 7.71594 15.732 8.12994 15.732H12.5889C13.0039 15.732 13.3389 16.068 13.3389 16.482C13.3389 16.896 13.0039 17.232 12.5889 17.232ZM8.12994 8.891H11.0729C11.4869 8.891 11.8229 9.227 11.8229 9.641C11.8229 10.055 11.4869 10.391 11.0729 10.391H8.12994C7.71594 10.391 7.37994 10.055 7.37994 9.641C7.37994 9.227 7.71594 8.891 8.12994 8.891ZM19.8519 9.094H16.8879C15.1219 9.085 13.6639 7.622 13.6639 5.838V2.698C13.6639 2.455 13.4709 2.25 13.2199 2.25H8.06494C5.66094 2.25 3.71094 4.229 3.71094 6.647V17.158C3.71094 19.693 5.75794 21.75 8.26794 21.75H15.9419C18.3459 21.75 20.2859 19.79 20.2859 17.372V9.533C20.2859 9.289 20.0929 9.094 19.8519 9.094Z",
    fill: "#BCBCBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.a867c9b2c4c92cfdff74eb160b2b516e.svg";
export { ForwardRef as ReactComponent };